import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setFilterIndicators } from '../../../redux/actions/filterIndicators';
import { setFilter } from '../../../redux/actions/filter';
import { Bubble } from '../BubbleElement/BubbleElement';
import { useTranslation } from 'react-i18next';
import { CalledFrom } from '../../../models/CalledFromEnum';
import useFilters from '../../../hooks/useFilters';

type Props = {
  indicatorCall?: boolean;
  calledFrom?: CalledFrom;
};

const handleBubblesAndActualState = ({
  calledFrom,
  filterEarlyWarnings,
  indicatorCall,
  filterIndicators,
  filterProjects,
}) => {
  if (calledFrom === CalledFrom.EARLY_WARNINGS) {
    return filterEarlyWarnings.common.participantDivisions;
  }
  return indicatorCall ? filterIndicators.common.participantDivisions : filterProjects.common.participantDivisions;
};

const ParticipatingDivisionBubbles = (props: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { indicatorCall, calledFrom } = props;
  const filterProjects = useSelector<any, any>(state => state.filter);
  const { filterEarlyWarnings, setFilterEarlyWarnings } = useFilters();
  const filterIndicators = useSelector<any, any>(state => state.filterIndicators);

  const bubbles = handleBubblesAndActualState({
    calledFrom,
    filterEarlyWarnings,
    indicatorCall,
    filterIndicators,
    filterProjects,
  });

  const closeBubble = (divisionId: number) => {
    const actualState = handleBubblesAndActualState({
      calledFrom,
      filterEarlyWarnings,
      indicatorCall,
      filterIndicators,
      filterProjects,
    });

    const newState = actualState.filter(division => division.id !== divisionId);

    if (CalledFrom.EARLY_WARNINGS === calledFrom) {
      dispatch(
        setFilterEarlyWarnings({
          ...filterEarlyWarnings,
          common: {
            ...filterEarlyWarnings.common,
            participantDivisions: newState,
          },
        }),
      );
    } else {
      if (indicatorCall) {
        dispatch(
          setFilterIndicators({
            ...filterIndicators,
            common: {
              ...filterIndicators.common,
              participantDivisions: newState,
            },
          }),
        );
      } else {
        dispatch(
          setFilter({
            ...filterProjects,
            common: {
              ...filterProjects.common,
              participantDivisions: newState,
            },
          }),
        );
      }
    }
  };

  return (
    <>
      {bubbles
        .filter(division => division.selectedByUser)
        .map(division => (
          <Bubble
            key={division.id}
            itsHidden={false}
            label={`${division.label} (${t('participating')})`}
            closeBubble={() => closeBubble(division.id)}
          />
        ))}
    </>
  );
};

export default ParticipatingDivisionBubbles;
